<script>
import { success, error } from '@/utils/alert'

/* eslint-disable */
const validators = {
  email: new RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ),
  url: new RegExp(
    /^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i
  ),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isodate: new RegExp(
    /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/
  )
};
/* eslint-enable */

export default {
  name: 'input-tag',
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    validate: {
      type: String | Function | Object,
      default: ''
    },
    addTagOnKeys: {
      type: Array,
      default: function () {
        return [
          13,   // Return
          188,  // Comma ','
          9     // Tab
        ]
      }
    },
    addTagOnBlur: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 15
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    professionalTags: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      newTag: '',
      innerTags: this.professionalTags,
      isInputActive: false
    }
  },

  watch: {
    tags () {
      this.innerTags = [...this.tags]
    }
  },

  computed: {
    isLimit: function () {
      return this.limit > 0 && Number(this.limit) === this.innerTags.length
    }
  },
  mounted: function () {
    this.getTags()
  },
  methods: {
    getTags () {
      this.$http.get('/v1/professional/keywords/keywords')
        .then((response) => {
          this.innerTags = [...response.data]
        })
    },
    saveTags () {
      if (this.innerTags.length > 0) {
        this.$http.post('/v1/professional/keywords/keywords', this.innerTags)
          .then((data) => {
            this.innerTags = [...data.data]
            success('Palavras chave salva(s) com sucesso.')
          })
      }
      if (this.innerTags.length <= 0) {
        error('Favor informar uma palavra chave.')
      }
    },
    focusNewTag () {
      if (this.readOnly || !this.$el.querySelector('.new-tag')) {
        return
      }
      this.$el.querySelector('.new-tag').focus()
    },

    handleInputFocus () {
      this.isInputActive = true
    },

    handleInputBlur (e) {
      this.isInputActive = false
      this.addNew(e)
    },

    addNew (e) {
      const keyShouldAddTag = e
        ? this.addTagOnKeys.indexOf(e.keyCode) !== -1
        : true

      const typeIsNotBlur = e && e.type !== 'blur'

      if (
        (!keyShouldAddTag && (typeIsNotBlur || !this.addTagOnBlur)) ||
        this.isLimit
      ) {
        return
      }

      if (
        this.newTag &&
        (this.allowDuplicates || this.innerTags.indexOf(this.newTag) === -1) &&
        this.validateIfNeeded(this.newTag)
      ) {
        this.innerTags.push(this.newTag)
        this.newTag = ''
        this.tagChange()
      }
    },

    validateIfNeeded (tagValue) {
      if (this.validate === '' || this.validate === undefined) {
        return true
      }

      if (typeof this.validate === 'function') {
        return this.validate(tagValue)
      }

      if (
        typeof this.validate === 'string' &&
        Object.keys(validators).indexOf(this.validate) > -1
      ) {
        return validators[this.validate].test(tagValue)
      }

      if (
        typeof this.validate === 'object' &&
        this.validate.test !== undefined
      ) {
        return this.validate.test(tagValue)
      }

      return true
    },

    remove (index) {
      this.innerTags.splice(index, 1)
      this.tagChange()
    },

    removeLastTag () {
      if (this.newTag) {
        return
      }
      this.innerTags.pop()
      this.tagChange()
    },

    tagChange () {
      this.$emit('update:tags', this.innerTags)
    }
  }
}
</script>

<template lang="pug">
    div
      .vue-input-tag-wrapper(
        @click='focusNewTag()',
        :class="{'read-only': readOnly, 'vue-input-tag-wrapper--active': isInputActive}")
        span.select-list(v-for='(tag, index) in innerTags', :key='index')
          | {{ tag }}
          span(v-if='!readOnly', @click.prevent.stop='remove(index)')
           .exclude 

        input.new-tag(
          v-if='!readOnly && !isLimit',
          ref='inputtag',
          :placeholder='placeholder',
          type='text',
          v-model='newTag',
          v-on:keydown.delete.stop='removeLastTag',
          v-on:keydown='addNew',
          v-on:blur='handleInputBlur',
          v-on:focus='handleInputFocus')

      button.btn.save.pull-right(@click.prevent="saveTags()")
        span.icon &#xE911;
        |  Salvar Palavras Chave
        .border-botton


</template>

<style>

.select-list {
  display: inline-block;
  padding: 5px 45px 5px 15px;
  margin: 1px;
  border-radius: 15px;
  border: 1px solid #ed193b;
  background-color: #ed193b;
  color: #fff;
  position: relative;
}

.select-list:hover,
.select-list.hover {
  -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
}

.select-list .exclude {
  font-family: 'agenda-font-icons';
  position: absolute;
  top: 0px;
  right: 15px;
  cursor: pointer;
  padding: 5px;
}

.select-list .exclude:hover {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.select-list:hover .exclude,
.select-list.hover .exclude {
  color: #fff;
}

.btn.save {
    border: 1px solid #00ce18;
    background: #fff;
    border-radius: 50px;
    color: #00ce18;
    margin-right: 10px;
}
.vue-input-tag-wrapper {
  background-color: #fff;
  border: 1px solid #ccc;
  overflow: hidden;
  padding-left: 4px;
  padding-top: 0px;
  cursor: text;
  text-align: left;
  -webkit-appearance: textfield;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.vue-input-tag-wrapper .input-tag {
  background-color: red;
  border-radius: 20px;
  border: 1px solid #fff;
  display: inline-block;
  margin-bottom: 4px;
  margin-right: 4px;
  padding: 5px;
  color: #fff;
  font-weight: bold;
}

.vue-input-tag-wrapper .input-tag .remove {
  font-family: 'agenda-font-icons';
  cursor: pointer;
  font-weight: bold;
  color: #fff;
}

.vue-input-tag-wrapper .input-tag .remove:hover {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.vue-input-tag-wrapper .input-tag .remove::before {
  font-family: 'agenda-font-icons';
}

.vue-input-tag-wrapper .new-tag {
  background: transparent;
  border: 0;
  color: #777;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 4px;
  padding-left: 5px;
  flex-grow: 1;
}

.vue-input-tag-wrapper.read-only {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/app/professional/record/registration/components/tags/tag.vue